import { VFC, useMemo } from 'react';
import { ElectricityMeasurementCategory } from '@enmon/commons';
import { FormattedMessage, useIntl } from 'react-intl';
import { Select } from '../../Select';
import { SelectMessages as messages } from '../../messages';
import { useMeterModelSuggestionsStore } from '../../../../store/useMeterModelSuggestionsStore';
import { getSelectOptionsWithSuggestions } from '../../utils/getSelectOptionsWithSuggestions';

interface ElectricityMeasurementCategorySelectProps {
  value?: ElectricityMeasurementCategory;
  onChange?: (value: ElectricityMeasurementCategory) => void;
}

export const ElectricityMeasurementCategorySelect: VFC<ElectricityMeasurementCategorySelectProps> = ({
  ...restProps
}: ElectricityMeasurementCategorySelectProps) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const electricityMeasurementCategoryOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: Object.values(ElectricityMeasurementCategory),
        suggestedValue: meterModelSuggestions?.measurementCategory?.value,
        suggestedSelection: meterModelSuggestions?.measurementCategory?.selection,
      }),
    [intl, meterModelSuggestions],
  );

  return (
    <Select
      allowClear
      showArrow
      className="w-100"
      options={electricityMeasurementCategoryOptions}
      placeholder={<FormattedMessage {...messages.measurementCategoryPlaceholder} />}
      {...restProps}
    />
  );
};
